"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../table/table-cells");
function useColumns(options) {
    const intl = react_intl_1.useIntl();
    const columns = react_1.useMemo(() => {
        var _a;
        return [
            ...((_a = options.columns) !== null && _a !== void 0 ? _a : []),
            {
                datakey: 'order',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_ORDER',
                    defaultMessage: 'Pořadí',
                }),
                width: 100,
                CellComponent: table_cells_1.TableCells.NumberCell,
                sortable: true,
                filterable: true,
            },
            {
                datakey: 'name',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_NAME',
                    defaultMessage: 'Název',
                }),
                width: 200,
                CellComponent: table_cells_1.TableCells.TextCell,
                sortable: true,
                filterable: true,
            },
            {
                datakey: 'active',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_ACTIVE',
                    defaultMessage: 'Aktivní',
                }),
                width: 100,
                CellComponent: table_cells_1.TableCells.BooleanCell,
                sortable: true,
                filterable: true,
            },
            {
                datakey: 'validFrom',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_VALID_FROM',
                    defaultMessage: 'Platnost od',
                }),
                width: 150,
                CellComponent: table_cells_1.TableCells.DateTimeCell,
                sortable: true,
                filterable: true,
            },
            {
                datakey: 'validTo',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_VALID_TO',
                    defaultMessage: 'Platnost do',
                }),
                width: 150,
                CellComponent: table_cells_1.TableCells.DateTimeCell,
                sortable: true,
                filterable: true,
            },
            {
                datakey: 'code',
                name: intl.formatMessage({
                    id: 'EAS_EVIDENCE_COLUMN_CODE',
                    defaultMessage: 'Kód',
                }),
                width: 100,
                CellComponent: table_cells_1.TableCells.TextCell,
                sortable: true,
                filterable: true,
            },
        ];
    }, [options.columns, intl]);
    return columns;
}
exports.useColumns = useColumns;
//# sourceMappingURL=dictionary-columns.js.map